/* eslint-disable react/jsx-no-comment-textnodes */
import type { ReactNode, ReactElement } from 'react';

import { forwardRef } from 'react';
import type { ForwardedRef } from 'react';
// material
import { alpha, styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export interface MButtonProps {
  children?: ReactNode;
  color?: string;
  variant?: any;
  [key: string]: any;
}

// ----------------------------------------------------------------------

// @ts-ignore legacy boundary
const ButtonStyle = styled(({ styleProps: _styleProps, ...other }) => (
  <Button {...other} />
  // @ts-ignore legacy boundary
))(({ theme, styleProps }) => {
  const { color, variant } = styleProps;

  const styleContained = (color) => ({
    // @ts-ignore legacy boundary
    boxShadow: theme.customShadows[color],
    color: theme.palette[color].contrastText,
    backgroundColor: theme.palette[color].main,
    '&:hover': {
      backgroundColor: theme.palette[color].dark,
    },
  });

  const styleOutlined = (color) => ({
    color: theme.palette[color].main,
    border: `1px solid ${alpha(theme.palette[color].main, 0.48)}`,
    '&:hover': {
      border: `1px solid ${theme.palette[color].main}`,
      backgroundColor: alpha(
        theme.palette[color].main,
        theme.palette.action.hoverOpacity
      ),
    },
  });

  const styleText = (color) => ({
    color: theme.palette[color].main,
    '&:hover': {
      backgroundColor: alpha(
        theme.palette[color].main,
        theme.palette.action.hoverOpacity
      ),
    },
  });
  return {
    ...(variant === 'contained' && { ...styleContained(color) }),
    ...(variant === 'outlined' && { ...styleOutlined(color) }),
    ...(variant === 'text' && { ...styleText(color) }),
  };
});

// ----------------------------------------------------------------------

const MButton = forwardRef(function MButtonImpl(
  { color = 'primary', variant = 'text', children, ...other }: MButtonProps,
  ref: ForwardedRef<HTMLElement>
) {
  if (color === 'inherit' || color === 'primary' || color === 'secondary') {
    return (
      // @ts-ignore legacy boundary
      <Button ref={ref} color={color} variant={variant} {...other}>
        {children}
      </Button>
    );
  }

  // Filter out styleProps to prevent it from being passed to DOM
  // eslint-disable-next-line no-unused-vars
  const { styleProps: _unused, ...domProps } = other;

  return (
    // @ts-ignore legacy boundary
    <ButtonStyle
      ref={ref}
      variant={variant}
      styleProps={{ color, variant }}
      {...domProps}
    >
      {children}
    </ButtonStyle>
  );
});

export default MButton;
